import { Badge, Group, Stack, Text } from "@mantine/core";
import { type FragmentOf, graphql, readFragment } from "gql.tada";

export const TournamentsStepResetFragment = graphql(`
  fragment TournamentsStepResetFields on TournamentsStepResetPayload {
    __typename
    stepId
    previousStatus
    newStatus
    reason
    cascade {
      affectedSteps
      affectedTeams
    }
  }
`);

interface Props {
  data: FragmentOf<typeof TournamentsStepResetFragment>;
}

export function TournamentsStepResetPayload({ data }: Props) {
  const p = readFragment(TournamentsStepResetFragment, data);
  return (
    <Stack gap={4}>
      <Group gap="xs" wrap="wrap">
        <Badge color="orange" size="xs">
          STEP RESET
        </Badge>
        <Text size="xs">
          step {p.stepId.slice(0, 8)}: {p.previousStatus} → {p.newStatus}
        </Text>
      </Group>
      <Text size="xs" c="dimmed">
        reason: {p.reason}
      </Text>
      <Text size="xs" c="dimmed">
        cascade: {p.cascade.affectedSteps} step
        {p.cascade.affectedSteps === 1 ? "" : "s"} · {p.cascade.affectedTeams}{" "}
        team
        {p.cascade.affectedTeams === 1 ? "" : "s"} affected
      </Text>
    </Stack>
  );
}
